let config = null;
let configPromise = null;
let resolveConfig = null;

configPromise = new Promise((resolve) => {
  resolveConfig = resolve;
});

export const setConfig = (newConfig) => {
  config = newConfig;
  if (resolveConfig) {
    resolveConfig(newConfig);
  }
};

export const getConfig = () => {
  return config || {};
};

export const waitForConfig = () => configPromise;
